import React, { useEffect, useState } from "react";
import { Divider, Stack, Typography } from "@mui/material";
import { ColorsV2 } from "app/constants/color";
import { useTranslation } from "react-i18next";
import { showAlert } from "app/utils";
import apiService from "app/services/apiService";
import { Loader } from "app/components";


const Organisation = () => {

    const [orgInfo, setOrgInfo] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const fetchOrgInfo = async () => {
        try {
            const res = await apiService.fetchOrgInfo();
            // At time of writing response data is included directly in the response as opposed to inside of a data field
            // To allow for backwards compatability when this is changed we set data conditionally
            const data = res?.data || res;
            setOrgInfo(data);
        }
        catch (error) {
            console.error(error);
            showAlert('error', `Unable to fetch organisation information: ${error.message}`);
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        fetchOrgInfo();
    }, [])

    const { t } =  useTranslation('translation', { keyPrefix: 'organisation' });

    return(
        isLoading ? 
        <Loader color={ColorsV2.acent} />
        :
        <Stack sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            marginTop: '6%',
            padding: '20px',
        }}>
            <Typography variant='h4' sx={{ color: ColorsV2.white, marginBottom: '20px', }}>
                {t('page_heading')}
            </Typography>
            <Divider sx={{ borderColor: ColorsV2.outline}} />
            <Stack direction='column'>
                <Typography variant='body1' sx={{ color: ColorsV2.white }}>
                   <span style={{ color: ColorsV2.textInfo }}>{t('org_name')} </span> {orgInfo?.displayName || ''}
                </Typography>
                <Typography variant='body1' sx={{ color: ColorsV2.white }}>
                    <span style={{ color: ColorsV2.textInfo }}>{t('org_nr')} </span> {orgInfo.orgNr || ''}
                </Typography>
                <Typography variant='body1' sx={{ color: ColorsV2.textInfo }}>
                        {t('accepted_domains')}
                </Typography>
                <Stack direction='column' sx={{ backgroundColor: ColorsV2.secondary, padding: '20px', paddingTop: '10px', marginTop: '10px', borderRadius: '4px', width: 'fit-content' }}>
                    {orgInfo.emailDomains?.map((domain) => ( 
                            <Typography variant='body2' key={domain} sx={{ color: ColorsV2.white }}>
                                {domain}
                            </Typography>
                        )
                    )}
                </Stack>
            </Stack>
        </Stack>
    )
}

export default Organisation;